const API_BASE_URL = process.env.REACT_APP_FIREBASE_API_URL;

class FeatureService {
  async getFeatureFlags() {
    try {
      const apiUrl = API_BASE_URL;
      if (!apiUrl) {
        throw new Error('API URL not configured');
      }

      const response = await fetch(`${apiUrl}/neuranet/features.json`);
      if (!response.ok) {
        throw new Error('Failed to fetch feature flags');
      }

      const features = await response.json();
      return features || {};
    } catch (error) {
      console.error('Error fetching feature flags:', error);
      return {};
    }
  }

  async isFeatureEnabled(featureName) {
    try {
      const features = await this.getFeatureFlags();
      return features[featureName] === true;
    } catch (error) {
      console.error(`Error checking feature ${featureName}:`, error);
      return false;
    }
  }
}

export default new FeatureService();